export default "__VITE_PUBLIC_ASSET__ffc5fce1__"